import React, { Component } from 'react';
import {Switch} from "../buttons/Swtich";
import ScheduleConfigurationContent from "./ScheduleConfigurationContent";
import {ItemScheduleConfiguration} from "../../utils/ItemScheduleConfiguration";
import { withTranslation } from 'react-i18next';


class ScheduleConfigurationClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enabled: this.props.itemScheduleConfiguration.hasScheduleConfiguration(),
            itemScheduleConfiguration: this.props.itemScheduleConfiguration
        };

        this.handleItemScheduleConfigurationChange = this.handleItemScheduleConfigurationChange.bind(this);
        this.handleEnabledChange = this.handleEnabledChange.bind(this);
    }

    handleItemScheduleConfigurationChange(itemScheduleConfiguration) {
        this.setState({...this.state, itemScheduleConfiguration: itemScheduleConfiguration}, ()=> { this.sendNewChangesToParentComponent()});
    }

    sendNewChangesToParentComponent() {
        this.props.onChange(this.state.itemScheduleConfiguration);
    }

    handleEnabledChange(event) {
        const enabled = event.target.checked;
        if(!enabled)
            this.setState({itemScheduleConfiguration: new ItemScheduleConfiguration(), enabled: false}, ()=> { this.sendNewChangesToParentComponent()});
        else
            this.setState({...this.state, enabled: true}, ()=> { this.sendNewChangesToParentComponent()});
    }

    renderScheduleConfigurationContent() {
        if (!this.state.enabled)
            return null;

        return <ScheduleConfigurationContent itemScheduleConfiguration={this.state.itemScheduleConfiguration}
                                          onChange={this.handleItemScheduleConfigurationChange}/>
    }

    render() {
        const { t } = this.props;
        return (
            <div style={{ marginTop: '20px' }}>
                <div className="form-row switch-input -horizontal" style={{paddingTop: "0", borderBottom: "0", marginBottom: "0", position: "relative", paddingBottom: "10px", zIndex: 2, justifyContent: 'flex-start', padding: 0}}>
                    <Switch style={{marginLeft: "0"}} onChange={this.handleEnabledChange} checked={this.state.enabled} name="enabled"/>
                    <div style={{paddingLeft:"10px", width:"100%", position: "relative"}}>
                        <label style={{paddingLeft:"10px", position: "relative", backgroundColor: "white", padding: "0 10px", marginLeft: "-10px", zIndex: 1}}>
                            {t('schedule_configuration.want_configure_days')}
                        </label>
                    </div>
                </div>
                {this.state.enabled && (
                    <div className="radio-box-border pe-0 pt-2">
                        <div className="form-row ms-0" style={{marginBottom: "0px"}}>
                            {this.renderScheduleConfigurationContent()}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export const ScheduleConfiguration = withTranslation()(ScheduleConfigurationClass);
export default ScheduleConfiguration;
